import { useToastStore } from '../store/toastStore';
import { CheckCircle, Info, XCircle, X } from 'lucide-react';

const ICONS = {
  success: CheckCircle,
  info: Info,
  error: XCircle,
};

const STYLES = {
  success: 'bg-green-600',
  info: 'bg-blue-600',
  error: 'bg-red-600',
};

export default function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts);
  const removeToast = useToastStore((s) => s.removeToast);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-3">
      {toasts.map((toast) => {
        const Icon = ICONS[toast.type || 'success'];
        return (
          <div
            key={toast.id}
            className={`${STYLES[toast.type || 'success']} text-white px-4 py-3 rounded-xl shadow-lg flex items-start gap-3 min-w-[280px] max-w-sm animate-in fade-in slide-in-from-right-4 duration-300`}
          >
            <Icon size={20} className="mt-0.5 flex-shrink-0" />
            <p className="text-sm font-medium flex-1">{toast.message}</p>
            <button
              onClick={() => removeToast(toast.id)}
              className="text-white/80 hover:text-white flex-shrink-0"
              aria-label="關閉"
            >
              <X size={18} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
